/**
 * Returns true when the email belongs to a FreightSimple employee. Used to
 * gate developer affordances (Component Inspector, theme picker, environment
 * badge) from customers — the dashboard is a public-facing app.
 *
 * Empty / undefined / non-string inputs return false so the gate fails
 * closed by default.
 */
export function isFreightSimpleEmployee(email: string | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith("@freightsimple.com");
}
